import { useState } from "react";
import { useScheduleEventStore } from "../../hooks";
import { Input } from "../../ui";

export const PatientInfoCard = () => {
  const {
    // Props
    scheduleEvent,
  } = useScheduleEventStore();

  const { patientSurgery } = scheduleEvent;
  const { patient } = patientSurgery;
  const { activeIndex, setActiveIndex } = useState(1);

  return (
    <div className="w-full">
      <ul className="nav nav-tabs">
        <li className="nav-item">
          <a className="nav-link active" aria-current="page">
            General
          </a>
        </li>
      </ul>
      <div className="card">
        <div className="card-body">
          <div className="row gy-4">
            {patient.user.firstName && (
              <div className="col-12 col-md-6 col-xl-4 col-xxl-3">
                <Input
                  label="Nombres"
                  type="text"
                  name="patientName"
                  value={patient.user.firstName}
                  onInputChange={() => {}}
                  disabled={true}
                />
              </div>
            )}
            {patient.user.lastName && (
              <div className="col-12 col-md-6 col-xl-4 col-xxl-3">
                <Input
                  label="Apellidos"
                  type="text"
                  name="patientLastName"
                  value={patient.user.lastName}
                  onInputChange={() => {}}
                  disabled={true}
                />
              </div>
            )}
            {patient.user.country && (
              <div className="col-12 col-md-6 col-xl-4 col-xxl-3">
                <Input
                  label="País de residencia"
                  type="text"
                  name="paientCountry"
                  value={patient.user.country}
                  onInputChange={() => {}}
                  disabled={true}
                />
              </div>
            )}
            {patient.user.department && (
              <div className="col-12 col-md-6 col-xl-4 col-xxl-3">
                <Input
                  label="Departamento de residencia"
                  type="text"
                  name="paientDepartment"
                  value={patient.user.department}
                  onInputChange={() => {}}
                  disabled={true}
                />
              </div>
            )}
            {patient.user.city && (
              <div className="col-12 col-md-6 col-xl-4 col-xxl-3">
                <Input
                  label="Ciudad de residencia"
                  type="text"
                  name="patientCity"
                  value={patient.user.city}
                  onInputChange={() => {}}
                  disabled={true}
                />
              </div>
            )}
            {patient.user.address && (
              <div className="col-12 col-md-6 col-xl-4 col-xxl-3">
                <Input
                  label="Dirección de residencia"
                  type="text"
                  name="patientAddress"
                  value={patient.user.address}
                  onInputChange={() => {}}
                  disabled={true}
                />
              </div>
            )}
            {patient.user.phoneNumber && (
              <div className="col-12 col-md-6 col-xl-4 col-xxl-3">
                <Input
                  label="Teléfono"
                  type="text"
                  name="patientPhone"
                  value={patient.user.phoneNumber}
                  onInputChange={() => {}}
                  disabled={true}
                />
              </div>
            )}
            {patient.user.email && (
              <div className="col-12 col-md-6 col-xl-4 col-xxl-3">
                <Input
                  label="Correo electrónico"
                  type="text"
                  name="patientEmail"
                  value={patient.user.email}
                  onInputChange={() => {}}
                  disabled={true}
                />
              </div>
            )}
            {patient.user.birthCountry && (
              <div className="col-12 col-md-6 col-xl-4 col-xxl-3">
                <Input
                  label="Pais de nacimiento"
                  type="text"
                  name="patientBirthCountry"
                  value={patient.user.birthCountry}
                  disabled={true}
                />
              </div>
            )}
            {patient.user.birthDepartment && (
              <div className="col-12 col-md-6 col-xl-4 col-xxl-3">
                <Input
                  label="Departamento de nacimiento"
                  type="text"
                  name="patientBirthDepartment"
                  value={patient.user.birthDepartment}
                  onInputChange={() => {}}
                  disabled={true}
                />
              </div>
            )}
            {patient.user.birthCity && (
              <div className="col-12 col-md-6 col-xl-4 col-xxl-3">
                <Input
                  label="Ciudad de nacimiento"
                  type="text"
                  name="patientBirthCity"
                  value={patient.user.birthCity}
                  onInputChange={() => {}}
                  disabled={true}
                />
              </div>
            )}
            {patient.user.birthAddress && (
              <div className="col-12 col-md-6 col-xl-4 col-xxl-3">
                <Input
                  label="Dirección de nacimiento"
                  type="text"
                  name="patientBirthAddress"
                  value={patient.user.birthAddress}
                  onInputChange={() => {}}
                  disabled={true}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
